import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import { UblInvoice } from '../../data/models'
import i18n from '../../utils/i18n'
import {
  getInvoiceTypeCodeString,
  invoiceTypeCodeToLocalizationKey,
} from './GetInvoiceTypeCodeString'

const invoiceTypes = Object.keys(
  invoiceTypeCodeToLocalizationKey,
) as UblInvoice['InvoiceTypeCode']['Value'][]

export const InvoiceTypeFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const valueTemplate = (
    option: UblInvoice['InvoiceTypeCode']['Value'],
    props: any,
  ) => {
    if (option) {
      return itemTemplate(option)
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: UblInvoice['InvoiceTypeCode']['Value']) => {
    return (
      <>
        {i18n.t(
          `eInvoiceOverview.table.columns.invoiceType.options.${getInvoiceTypeCodeString(
            option,
          )}`,
        )}
      </>
    )
  }

  return (
    <Dropdown
      value={options.value}
      options={invoiceTypes}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t(
        'eInvoiceOverview.table.columns.invoiceType.filterPlaceholder',
      )}
    />
  )
}
